import { isIOSDevice } from './isIOSDevice';
import { toNumber } from 'lodash';

export const unfixBodyScroll = () => {
  const body = document.querySelector('body')!;

  if (!isIOSDevice()) {
    body.style.overflow = 'visible';
  }

  if (isIOSDevice()) {
    body.style.position = 'initial';
    body.style.left = 'initial';
    body.style.right = 'initial';
    body.style.top = 'initial';
    body.style.bottom = 'initial';

    if (body.hasAttribute('data-scroll-offset')) {
      window.scrollTo(0, toNumber(body.getAttribute('data-scroll-offset')));
      body.removeAttribute('data-scroll-offset');
    }
  }
};
